module.exports = __webpack_public_path__ + "52470b2fce5282836369434e6e832472.png";